import React, { Component } from 'react'
import SequencedTitle from './title'
import UsingHook from './using-hook'
import styled from 'styled-components'

const Header = styled.div`
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #fff;
  padding: 30px;
`

const HeaderButtons = styled.div`
  display: flex;
  justify-content: center;
  > * {
    margin: 0 1rem;
  }
`

const Main = styled.main`
  max-width: 1000px;
  margin: 0px auto;
  padding: 100px 50px;
`

const Intro = styled.p`
  margin: 40px 0;
`

const Section = styled.div`
  margin-bottom: 50px;
`

const CodeEmbed = styled.iframe`
  width: 100%;
  height: 500px;
  overflow: hidden;
  border-radius: 4px;
`

const NavLink = styled.a`
  font-size: 20px;
  text-decoration: none;
`

class App extends Component {
  render() {
    return (
      <div>
        <Header>
          <SequencedTitle />
          <Intro>
            The smarter way to perform complex animations and transitions in
            React.
          </Intro>
          <HeaderButtons>
            <a
              className="github-button"
              href="https://github.com/amized/react-sequencer"
              data-icon="octicon-star"
              data-size="large"
              aria-label="Star ntkme/github-buttons on GitHub"
            >
              Star
            </a>
            <a
              className="github-button"
              href="https://github.com/amized/react-sequencer/fork"
              data-icon="octicon-repo-forked"
              data-size="large"
              aria-label="Fork ntkme/github-buttons on GitHub"
            >
              Fork
            </a>
            <NavLink href="https://github.com/amized/react-sequencer/blob/master/README.md">
              Docs
            </NavLink>
          </HeaderButtons>
        </Header>
        <Main>
          <Section>
            <h2>End modes</h2>
            <p>
              With the endMode option you can control how the sequencer behaves
              when it reaches the end of the sequence.
            </p>
            <h3>Example</h3>
            <CodeEmbed
              src="https://codesandbox.io/embed/react-sequencer-endmodes-ow8js?fontsize=14&theme=dark"
              title="react sequencer endmodes"
              allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking"
              sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
            />
          </Section>
          <Section>
            <h2>A content fader</h2>
            <p>
              React sequencer is very useful for building complex transitions
              where you need to bring some elements in and and out by applying
              css to both elements in a synchronized fashion. This example shows
              how easy it is to build a content fader component, which smoothly
              animates the height and opacity to create a seamless transition.
            </p>
            <h3>Example</h3>
            <CodeEmbed
              src="https://codesandbox.io/embed/muddy-fire-n5311w4l70?fontsize=14&module=%2Fsrc%2Fcontent-fader.js&theme=dark"
              title="content-fader"
              allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking"
              sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
            />
          </Section>
          <Section>
            <h2>A slide down widget</h2>
            <p>
              By using two useSequencer hooks in a compnent you can create
              powerful show/hide animations. Below is an example of a slide down
              that uses a sequencer for the "in" transition and another for the
              "out" transition. With this we are able to animate the transition
              with pure css.
            </p>
            <h3>Example</h3>
            <CodeEmbed
              src="https://codesandbox.io/embed/slide-down-lui5k?fontsize=14&module=%2Fsrc%2Fslide-down.tsx&theme=dark"
              title="slide-down"
              allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking"
              sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
            ></CodeEmbed>
          </Section>
          <Section>
            <h2>Step properties</h2>
            <p>
              React sequencer allows you to add properties to steps simply by
              passing an object as the step name rather than a string. This is a
              powerful way configure complex sequences.
            </p>
            <h3>Example</h3>
            <CodeEmbed
              src="https://codesandbox.io/embed/object-names-jjjtc?fontsize=14&moduleview=1&theme=dark"
              title="object names"
              allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking"
              sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
            />
          </Section>
        </Main>
      </div>
    )
  }
}

export default App
